import { useEffect } from "react";
import { useSelector } from "@jti/store";
import { useGtm } from "../../hooks/gtm/useGtm";
import { useFreeTrial } from "../../hooks/useFreeTrial";
import { useOrder } from "../../hooks/useOrder";
export const CheckoutProgressGtmObserver = ({ step }) => {
    const { order, orderFetchStatus } = useOrder();
    const { dispatchGtmCheckoutProgress, dispatchGtmPageViewEvent } = useGtm();
    const { isFreeTrial } = useFreeTrial();
    const defaultCart = useSelector((state) => state.cart);
    const freeTrialCart = useSelector((state) => state.freeTrialCart);
    const areItemsLoading = isFreeTrial ? freeTrialCart.areItemsLoading : defaultCart.itemsPending;
    useEffect(() => {
        dispatchGtmPageViewEvent();
    }, []);
    useEffect(() => {
        if (!step) {
            return;
        }
        const cart = isFreeTrial ? freeTrialCart : defaultCart;
        const trackingData = order || cart;
        const isTrackingDataEmpty = (trackingData?.items ?? []).length === 0;
        const shouldSetTracking = !defaultCart.notLoggedIn && !areItemsLoading && orderFetchStatus !== "pending" && !isTrackingDataEmpty;
        if (shouldSetTracking) {
            dispatchGtmCheckoutProgress(trackingData, step);
        }
    }, [step, isFreeTrial, defaultCart, freeTrialCart.items, order]);
    return null;
};
//# sourceMappingURL=CheckoutProgressGtmObserver.js.map